import { ROUTES } from '@/features/core/container';
import { option } from '@/util/container';
import { component } from '../component';
import { APP_CUSTOMER } from './app.builder';

export default option(ROUTES, async () => {
  return [
    {
      path: '/customer/:customerId/vendor-apis/alert-mail/:vendorApiId',
      component: component('views/alert-mail-configuration/AlertMailConfigurationView.vue'),
      props: true,
      meta: { app: APP_CUSTOMER, key: (): string => `AppCustomer/VendorApis/AlertMail` },
      children: [
        {
          path: '/customer/:customerId/vendor-apis/alert-mail/:vendorApiId',
          name: 'AppCustomer/VendorApis/AlertMailConfiguration',
          meta: { app: APP_CUSTOMER },
          beforeEnter: ({ params }, from, next) =>
            void next({ name: 'AppCustomer/VendorApis/AlertMailConfiguration/Settings', params }),
        },
        {
          path: 'settings',
          name: 'AppCustomer/VendorApis/AlertMailConfiguration/Settings',
          component: component('views/alert-mail-configuration/settings/SettingsView.vue'),
          props: true,
          meta: { app: APP_CUSTOMER },
        },
      ],
    },
  ];
});
